
import useDriver from "./useDriver";
import useDriverTeams from "./useDriverTeams";
import useDriverCharges from "./useDriverCharges";
import useDriverConfig from "./useDriverConfig";
import useDriverKYC from "./useDriverKYC";
import useDriverKYCUpload from "./useDriverKYCUpload";
import useNotification from "../useNotification";

export default function useDriverAllApi() {

  const {
    drivers,
    loading,
    fetchDrivers,
    deleteDriver,
    toggleDutyStatus,
    createDriverApi,
    editDriverApi,
    updateDriverDutyApi,
  } = useDriver();

  //  TEAMS 
  const {
    teams,
    teamsLoading,
    fetchDriverTeams,
    driverTeams,
    loadingTeams,
    fetchDriverMultipleTeams,
    updateDriverActiveTeam,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
  } = useDriverTeams();

  // CHARGES 
  const {
    chargeRows,
    chargesLoading,
    fetchDriverCharges,
    fetchChargesForDriverApi,
     saveDriverChargeApi,
  } = useDriverCharges(drivers);

  //  CONFIG 
  const {
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,
  } = useDriverConfig();

  // KYC 
  const {
    kycDrivers,
    fetchDriverKycDetails,
    handleKycAction,
    handleStepSubmit,
  } = useDriverKYC();

  //  KYC UPLOAD 
  const { uploadImageToServer } = useDriverKYCUpload();

// notification
   const { sendNotification } = useNotification();  

  //  COMBINE EVERYTHING 
  return {
    drivers,
    kycDrivers,
    loading,
    teams,
    fetchDriverTeams,
    fetchDrivers,
    editDriverApi,
    updateDriverDutyApi,
    driverTeams,
    updateDriverActiveTeam,
    loadingTeams,
    fetchDriverMultipleTeams,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
    deleteDriver,
    toggleDutyStatus,

    // configs
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,

    // charges
    chargeRows,
    chargesLoading,
    fetchDriverCharges,
    fetchChargesForDriverApi,
    saveDriverChargeApi,

    // KYC helpers (MOST IMPORTANT FIX)
    uploadImageToServer,
    handleStepSubmit,
    fetchDriverKycDetails,                 
    handleKycAction: handleKycAction,     

    // config helpers
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteSingleDriverConfig,   
    
    sendSingleNotificationApi: sendNotification,
  };
}
